import { rem } from "polished";
import * as React from "react";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

const ResponsiveSVG = withViewportStyle("svg")`
  height: ${rem(100)};
  width: ${rem(200)};

  ${(props) => props.$viewport.tablet`
    height: ${rem(70)};
    width: ${rem(140)};
  `}

  ${(props) => props.$viewport.mobile`
    height: ${rem(40)};
    width: ${rem(80)};
  `}
`;

export const Semicircle = () => {
  return (
    <ResponsiveSVG
      className="semicircle"
      data-testid="semicircle-vector"
      viewBox="0 0 200 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M200 100C200 73.4784 189.464 48.043 170.711 29.2893C151.957 10.5357 126.522 2.00233e-06 100 0C73.4784 -2.00233e-06 48.043 10.5357 29.2893 29.2893C10.5357 48.0429 4.00466e-06 73.4783 0 100L100 100H200Z" />
    </ResponsiveSVG>
  );
};
